import { Parameter } from '@src/main/modules/parameters/domain/parameters-management/parameter.interface';
import { ParameterRepository } from '@src/main/modules/parameters/domain/parameters-management/parameter.repository';

export const findAllParameters = async (repository: ParameterRepository): Promise<Parameter[]> =>
  await repository.findAll();
